import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

//Material UI
import { Paper, Typography, Grid, Box } from '@mui/material';

//Component
import { DataGrid, ViewButton, FabContainer, CreateFab } from '@arredo/reactjs-ui';
import Filters from '../cashRegisters/filters';
import Fab from '@mui/material/Fab';
import GetAppIcon from '@mui/icons-material/GetApp'

//Hooks
import useNotify from "../../hooks/notify";
import useUser from "../../hooks/user/useUser";
import useClosures from "../../hooks/closures/useClosures";
import useAuthorize from '../../hooks/user/useAuthorize';

//Models
import { Permissions } from '../../models/Roles';
import { title, columns } from "../../models/ClosureEntity";

// Others
import { subChannels } from "../../models/Channels";
import useStyles from './styles';
import billingService from "../../services/billingService";

const Closures = () => {
    const { classes } = useStyles();
    const isAuthorized = useAuthorize();
    const push = useNavigate();
    const { closures, loading, totalPage, filters, search, setParameterSearch, clearFilters } = useClosures();
    const { Notify, variants } = useNotify();
    const { cashRegister, business } = useUser();
    const [pvs, setPvs] = useState([]);

    useEffect(() => {
        const setDefaultDate = () =>
            setParameterSearch({
                ...filters,
                from: new Date().toISOString().replace(/T.*/, '')
            });

        if (filters && (!filters.from && filters.from === '' && search?.indexOf('from') === -1))
            setDefaultDate();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (cashRegister.associatePvs) {
            const pvs = cashRegister.associatePvs.filter(pv => pv.subChannel === subChannels.values.ControladorFiscal)
            setPvs(pvs);
        }
    }, [cashRegister]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleFilterChange = (event) =>
        setParameterSearch({
            ...filters,
            [event.target.name]: event.target.value
        });

    const handleChangePage = (e, page) =>
        setParameterSearch({
            ...filters,
            pageNumber: Number(page)
        })

    const handleTicketZClick = () => {
        Notify("Se envió a imprimir ticket Z correctamente.", variants.SUCCESS)
        billingService
            .PrintCloseZ(pvs[0].billingCode, business.id)
            .then(res => Notify("El ticket Z se imprimio correctamente.", variants.SUCCESS))
            .catch(err => Notify(err.message, variants.ERROR))
    }

    return (
        <>
            <Grid container spacing={1}>
                <Grid size="grow">
                    <Box component={Paper} padding={2}>
                        <Typography variant="h4">
                            {title}
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={12}>
                    <Filters filters={filters} clearFilters={clearFilters} onFilterChange={handleFilterChange} />
                </Grid>
                <Grid size={12}>
                    <DataGrid
                        columns={columns}
                        rows={closures}
                        loading={loading}
                        paginationProps={{
                            count: totalPage,
                            page: filters?.pageNumber || 1,
                            onChange: handleChangePage
                        }}
                        actions={
                            ({ row }) => (
                                <>
                                    {isAuthorized([Permissions.CashregisterView]) && (
                                        <ViewButton
                                            to={`/cashRegisters/closures/${row.id}`}
                                        />
                                    )}
                                </>
                            )
                        }
                    />
                </Grid>
            </Grid>
            <FabContainer>
                {isAuthorized([Permissions.CashregisterView]) && <CreateFab onClick={() => push(`/cashRegisters/closures/create`)} />}
                {
                    pvs.length > 0 && (

                        <Fab
                            color='primary'
                            variant="extended"
                            className={classes.fab}
                            onClick={() => handleTicketZClick()}
                        >
                            <GetAppIcon />
                            Ticket Z
                        </Fab>
                    )
                }
            </FabContainer>
        </>
    );
}

export default Closures;